const TRP_CLIENT_URL = process.env.REACT_APP_TRP_CLIENT_URL || 'https://opeva-clientes-trp-dev.jphlions.com';
const SERVICE_TOKEN = process.env.REACT_APP_TRP_SERVICE_TOKEN || '';

const headers = {
  'x-service-token': SERVICE_TOKEN,
  'Content-Type': 'application/json'
};

const amarreApiService = {
  async getTipoOperativos() {
    const res = await fetch(`${TRP_CLIENT_URL}/amarre/tipo-operativos`, { headers });
    const data = await res.json();
    return data.data || [];
  },

  async getOperativos(tipoOperativo) {
    if (!tipoOperativo) return [];
    const res = await fetch(`${TRP_CLIENT_URL}/amarre/operativos?tipoOperativo=${tipoOperativo}`, { headers });
    const data = await res.json();
    return data.data || [];
  },

  async getLugares(tipoOperativo) {
    if (!tipoOperativo) return [];
    const res = await fetch(`${TRP_CLIENT_URL}/amarre/lugares?tipoOperativo=${tipoOperativo}`, { headers });
    const data = await res.json();
    return data.data || [];
  },

  async getParticipantes({ fecha, turno, operativo, lugarOperativo }) {
    if (!fecha || !turno || !operativo || !lugarOperativo) return [];
    const params = new URLSearchParams({ fecha, turno, operativo, lugarOperativo });
    const res = await fetch(`${TRP_CLIENT_URL}/amarre/participantes?${params}`, { headers });
    const data = await res.json();
    return data.data || [];
  }
};

export default amarreApiService;
